import { Button } from "@mui/material";
import ChipsTableCellComponent from "../ChipsTableCell.Component";
import UpdateMrqBtn from "../ChangeOrderBtn/UpdateMrqBtn";
import UpdatePOBtn from "../ChangeOrderBtn/UpdatePoBtn";

// Helper function to find the latest revision with data for unchanged material
const findLatestRevisionWithData = (
  revisions,
  currentIndex,
  tagNumber,
  currentMaterial,
  dataAccessor,
) => {
  const sortedRevs = revisions.sort((a, b) => a.revision - b.revision);

  let hasChanged = false;
  ["description"].forEach((key) => {
    if (currentMaterial[key]) {
      // Check if description changed from any previous revision
      for (let i = currentIndex - 1; i >= 0; i--) {
        const prevMaterial = sortedRevs[i]?.materials?.find(
          (pm) => pm.taggedMaterial?.tagNumber === tagNumber,
        );
        if (prevMaterial && currentMaterial[key] !== prevMaterial[key]) {
          hasChanged = true;
          break;
        }
      }
    }
  });

  // If material hasn't changed, find the latest revision with the data
  if (!hasChanged) {
    for (let i = currentIndex - 1; i >= 0; i--) {
      const material = sortedRevs[i]?.materials?.find(
        (pm) => pm.taggedMaterial?.tagNumber === tagNumber,
      );
      if (material) {
        const data = dataAccessor(material);
        if (data) {
          return data;
        }
      }
    }
  }

  return null;
};

export const drawingMcsDataCols = [
  {
    accessorKey: "mrqNumber",
    header: "MRQ #",
    enableEditing: false,
    size: 90,
    Cell: ({ row }) => {
      const chips = row.original.mrqChips || [];
      const hasChanged = row.original.hasChanged;
      const notRev0 = row.original.notRev0;
      const drawing = row.original.drawing;
      const previousDrawing = row.original.previousDrawing;

      const hasPreviousMrq = row.original.hasPreviousMrq;
      // console.log("cccchip", chips);
      return chips?.[0] ? (
        <ChipsTableCellComponent type="mrq" chips={chips} />
      ) : notRev0 && hasPreviousMrq && hasChanged ? (
        <UpdateMrqBtn
          material={row.original}
          drawing={drawing}
          previousDrawing={previousDrawing}
        />
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "poNumber",
    header: "PO #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      const chips = row.original.poChips || [];
      const hasChanged = row.original.hasChanged;
      const notRev0 = row.original.notRev0;
      const drawing = row.original.drawing;
      const previousDrawing = row.original.previousDrawing;

      const hasPreviousPo = row.original.hasPreviousPo;
      const previousPO = row.original.previousPO;

      return chips?.[0] && !hasChanged ? (
        <ChipsTableCellComponent type="po" chips={chips} />
      ) : notRev0 && hasPreviousPo && hasChanged ? (
        // <UpdatePOBtn
        //   drawing={drawing}
        //   previousPO={previousPO}
        //   previousDrawing={previousDrawing}
        // />
        ""
      ) : (
        ""
      );
    },
  },

  {
    accessorKey: "budgetedCost",
    header: "Budgeted Cost($)",
    enableEditing: false,
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "totalCost",
    header: "Actual Cost($)",
    enableEditing: false,
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  // {
  //   accessorKey: "difference",
  //   header: "Difference($)",
  //   enableEditing: false,
  //   size: 20,
  //   muiTableHeadCellProps: {
  //     align: "center",
  //   },
  //   muiTableBodyCellProps: {
  //     align: "center",
  //   },
  // },
  {
    accessorKey: "schedule",
    header: "Schedule",
    enableEditing: false,
    size: 70,

    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      let date = row.original.schedule;

      return date ? "in " + date + " Days" : "";
    },
  },
  {
    accessorKey: "vendor",
    header: "Vendor",
    enableEditing: false,
    size: 90,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "mrvNumber",
    header: "MRV #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      const chips = row.original.mrvChips || [];

      return chips?.[0] ? (
        <ChipsTableCellComponent type="mrv" chips={chips} />
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "srvNumber",
    header: "SRV #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      let chips = row.original.srvChips || [];

      return chips?.[0] ? (
        <ChipsTableCellComponent type="srv" chips={chips} />
      ) : (
        ""
      );
    },
  },
  // {
  //   accessorKey: "balance",
  //   header: "Balance Qty Length",
  //   enableEditing: false,
  //   size: 70,
  //   Cell: ({ row }) => {
  //     return (
  //       <StockQtyInput
  //         row={row}
  //         name="estCost"
  //         placeholder="balance"
  //         defaultValue={row.original.estCost}
  //       />
  //     );
  //   },
  // },

  {
    accessorKey: "heatNumber",
    header: "Heat #",
    enableEditing: false,
    size: 70,
  },

  {
    accessorKey: "remarks",
    header: "Remarks",
    enableEditing: false,
    size: 30,
  },
];
